import { Box, Img } from '@chakra-ui/react';
import { WSysLayout, WSysPreferences, useWSysPath } from "@coimbra-its/websys-ux-core";
import "@fontsource/montserrat";
import { Dashboard } from './features/Dashboard';
import { useSunStore } from './store/sunSlice';

import { SunBlock } from './components/Sun';
import { useWSysAppkit } from './web3/web3';


export function App() {

	const path = useWSysPath();
	useWSysAppkit();

	const connectedWallet = useSunStore((state) => state.connectedWallet)
	const walletBox = <SunBlock py={3} {...!!connectedWallet && { header: 'Connected wallet' }}>
		<appkit-button />
	</SunBlock>;

	const user = useSunStore(state => state.user);



	return <>
		<Box position='fixed' left='50px' top='44px' color='#fff'>
			<Img src='images/sunmoney_logo.png' w='121px' /><br />
		</Box>
		<WSysLayout >
			{/*path.on('wallet', <Wallet />)*/}
			{path.on('preferences', <WSysPreferences />, { group: 99 })}
			{path.elseOpen(<Dashboard walletBox={walletBox} />)}
		</WSysLayout>

	</>
}